import React, { Component } from 'react';
import { Link } from 'react-router-dom'; 
import * as Lang from '../lang';
class HeaderPage extends Component {
  componentDidMount() {
    document.title = Lang.LANG_TITLE;
  } 
  render() { 

    const col_parent = { 
      fontFamily: "Arial", 
      minHeight:"50px", 
    };
    const img = {  
      width:"90%", 
    };
    return (
      <div>
        <div className="d-flex flex-column flex-md-row align-items-center px-md-4 mb-1 bg-white border-bottom shadow-sm class-header" style={col_parent}>
          <nav className="my-0 mr-md-auto font-weight-normal"><Link to="/dashboard"><img src={require('../logo_pacs.png')} alt={Lang.LANG_TITLE} style={img}/></Link></nav>
          <nav className="my-2 my-md-0 mr-md-3">
           Xin chào <strong>{localStorage.getItem('name')}</strong>, <Link to='/logout'>Đăng xuất</Link>
          </nav> 
        </div>  
      </div>
    );
  }
}

export default HeaderPage;
